﻿
import { Component, Input, NgModule, OnInit, Output, Inject, OnDestroy, ElementRef, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import * as Survey from 'survey-angular';
import { SurveyService } from '../shared/service/SurveyService';

import { NotificationsService } from 'angular2-notifications';
import { DialogService } from '../shared/service/dialog.service';
import { LanguageLocalisationComponent } from '../shared/component/Localisation/language-localisation.component';
import { AuthService } from '../shared/security/auth.service';
import { User } from '../shared/security/user';
import { surveyLocalization } from 'survey-angular';
import { IsurveyResult } from '../Shared/models/SurveyResult';
import { Imail } from '../Shared/models/mail';
import *  as showdown from 'showdown';
import { request } from 'http';
import { isNumber } from 'util';
import { dashCaseToCamelCase } from '@angular/compiler/src/util';

const dateRegEx = new RegExp("[0-9]{4}-[0-9]{2}-[0-9]{2}");
@Component({
    selector: 'app-survey',
    templateUrl: './survey.component.html',

})

export class SurveyComponent implements OnInit {

    private localTextDisplay: string;
    public JSON;
    public surveyJSON;
    public surveyModel = new Survey.Model('');
    public localeID: string = "";
    public routePath: string;
    public isLoaded: boolean = false;
    private surveyIdToCheck;
    private element: HTMLElement;
    private surveyId: number;
    public localText: string;
    public mail: Imail;
    public activeSurveyTitle: string;
    public user: User = null;
    public mailReceiver: string;
    

    @Output() sendlocalText: EventEmitter<any> = new EventEmitter();
    @Input() surveyID: number;
    @ViewChild(LanguageLocalisationComponent) langViewChild: LanguageLocalisationComponent;

    constructor(@Inject(DOCUMENT) document,
        private route: ActivatedRoute,
        private router: Router,
        private _surveyService: SurveyService,
        private auth: AuthService,
        private flash: NotificationsService,
    ) {


    }
    ngOnInit() {
       

        this.route.paramMap.subscribe((params: ParamMap) => {
            this.surveyIdToCheck = params.get('surveyID');
            this.routePath = this.router.url.split('/')[2];
          

        });


        if (this.routePath == 'preview') {

            this.auth.user.then(user => {
                this.user = user;
               
            }).catch(user => {
                //console.log('catch');
                //console.log(user);
            })
                .then(user => {
                    this._surveyService.previewSurvey(this.surveyIdToCheck)
                        .then(x => {

                            this.JSON = x;
                            if (this.JSON != undefined) {
                                this.onAngularComponentInit();
                            }


                        });

                })

        }
        else {
          //  console.log('freeRoute');
            this._surveyService.getSurvey(this.surveyIdToCheck)
                .then
                (x => {

                    this.JSON = x;
                    if (this.JSON != undefined) {
                        this.onAngularComponentInit();
                    }

                })
        }




    }



    ngOnDestroy() {

    }

    public onAngularComponentInit() {


        this.surveyJSON = JSON.parse(this.JSON['surveyJSON']);
        this.surveyModel = new Survey.Model(this.surveyJSON);
       // console.log(this.surveyJSON);
        //this.localeID = this.surveyModel.getLocale();
        Survey.defaultBootstrapCss.navigationButton = "btn btn-primary";
        Survey.defaultBootstrapCss.rating.item = "btn btn-primary my-rating";
        Survey.defaultBootstrapCss.matrix.root = "table table-striped";
        Survey.defaultBootstrapCss.pageTitle = "btn btn-warning"
        Survey.Survey.cssType = "bootstrap";//EchrBootstrap

        this.mailReceiver = this.surveyJSON.mailReceiver;


        Survey.surveyLocalization.currentLocale = Survey.surveyLocalization.defaultLocale;
        this.surveyModel.locale = Survey.surveyLocalization.defaultLocale.toString();
        if (this.routePath == "French") {
            //Survey.surveyLocalization.defaultLocaleValue = "fr";
            Survey.surveyLocalization.currentLocaleValue = "fr";
            this.surveyModel.locale = "fr";
            this.surveyModel.setValue('locale', 'fr');
        }


        var myCss = {
            matrix: { root: "table table-striped matrixtable" },
        };

        Survey
            .SurveyNG
            .render("surveyElement", {
                model: this.surveyModel,
                css: myCss
                //  css: 'EchrBootStrap.css'
            });

        this.surveyModel
            .onPartialSend
            .add(this.TreatPartial);

        this.surveyModel.onComplete.add(this.sendDataToServer);

        this.surveyModel
            .onUpdateQuestionCssClasses
            .add(function (survey, options) {
                var classes = options.cssClasses

                classes.root = "sq-root";
                classes.title = "sq-title";
                classes.item = "sq-item";
                classes.label = "sq-label";

                if (options.question.isRequired) {
                    classes.title = "sq-title sq-title-required";
                    classes.root = "sq-root sq-root-required";
                }

                if (options.question.getType() === "checkbox") {
                    classes.root = "sq-root sq-root-cb";
                }
            });

        ////Create showdown mardown converter
        var converter = new showdown.Converter();
        this.surveyModel
            .onTextMarkdown
            .add(function (survey, options) {
                //convert the mardown text to html
                var str = converter.makeHtml(options.text);
                //remove root paragraphs <p></p>
                str = str.substring(3);
                str = str.substring(0, str.length - 4);
                //set html
                options.html = str;
            });
        if (this.routePath == "English" || this.surveyModel.locale == "en") {

            this.langViewChild.localText = "français";

            this.activeSurveyTitle = this.surveyJSON.title.default;
            Survey.surveyLocalization.currentLocaleValue = "en";
            this.surveyModel.setValue('locale', 'en');
            this.surveyModel.render();

        }
        else {
            this.langViewChild.localText = "english";
            this.surveyModel.setValue('locale', 'fr');
            this.activeSurveyTitle = this.surveyJSON.title.fr;
            //Survey.surveyLocalization.currentLocaleValue = "fr";
            this.surveyModel.render();
        }


        //   this.setLocales();

    }
    public setLocales() {
        var that = this;
        this.surveyModel.setValue('locale', 'fr');

        that.surveyModel.render();

    }
    public defineLocales = () => {


        var that = this;
        if (that.langViewChild.localText == "english") {

            that.surveyModel.locale = "en";
            this.surveyModel.setValue('locale', 'en');

            //Survey.surveyLocalization.currentLocaleValue="en"
            that.localText = "français";
            that.langViewChild.localText = that.localText;
            that.activeSurveyTitle = that.surveyJSON.title.default;

        }
        else {
            that.surveyModel.locale = "fr";
            that.localText = "english";
            this.surveyModel.setValue('locale', 'fr');

            that.activeSurveyTitle = that.surveyJSON.title.fr;
            //Survey.surveyLocalization.currentLocaleValue = "fr"

        }
        that.langViewChild.localText = that.localText;
         return true;

    }
    public TreatPartial = (result) => {
        //function (result) {
        var modifiedData = Object.keys(result.data).map(function (qName) {
            return {
                value: result.data[qName],
                questionid: result.getQuestionByName(qName).getValueName//.questionid

            }
        });

        this.element
            .querySelector('#surveyResult')
            .innerHTML = "result: " + JSON.stringify(modifiedData);
        //});

    }


    public sendDataToServer = (survey) => {

        //console.log(survey);

        var data = [];
        //for (var key in survey.data) {
        for (var key in survey.getAllQuestions()) {
            var question = survey.getQuestionByValueName(key);
            if (!question) {
                question = survey.getAllQuestions()[key];
                //to see
                if (!question) continue;
             }
                var questionResult = { name: key, value: survey.data[key], title: question.title, displayValue: this.stringifyDateVal(question.displayValue) }
           
            data.push(questionResult);
        }
       


        //var modifiedData = Object.keys(survey.data).map(function (qName) {
        //    console.log(survey.getQuestionByName(qName).title + ': ' + survey.data[qName]);

        //    return {
        //        value: survey.data[qName],
        //        questionid: survey.getQuestionByName(qName).title//.questionid

        //    }

        //});



        //var surveyAnswer: IsurveyResult = { answerText: JSON.stringify(survey.data,this.stringifyDate), answerDate: new Date(), surveyId: this.surveyID };
        var requester = '';
        var result = '';

                       data.forEach(function (value) {
            //if (value.name === 'Inquirer:Email') 
            //console.log('titil' + value.title);
            //console.log('disy' + value.displayValue);
            //console.log('name' + value.name);
            if (value.title === 'Email' || value.title === 'E-mail') {
                requester = value.displayValue;

            }
          
                if (value.displayValue === 'ECHRTitle') {
                    result = result + '<h3 style="margin-bottom:1px;margin-top:8px;">' + value.title + '</h3>';
                }
                else {
                    if(value.displayValue.length > 0)
                    {
                        result = result + value.title + ': <strong>' + value.displayValue + '</strong>' + '<br> ';
                    }
                }
          
            return result;
        });

        //Requester
        if (requester != "")
            this.sendMails(result, requester,"");
        //ECHR
        if (this.mailReceiver != "")
            
        this.sendMails(result, this.mailReceiver,requester);
    }

    public stringifyDate = (key, val) => {
        
        return this.stringifyDateVal(val);
    }
    public stringifyDateVal = ( val) => {

        if (dateRegEx.test(val))
            return (<string>val).split("-").reverse().join("/");
        return val;
    }
    public sendMails = (message, requester,from) => {
        if (requester != '') {
            var posmailto = message.indexOf("mailto");
            var mailmessage = message.slice(0, posmailto);

            this.mail = {} as Imail;
            this.mail.body = mailmessage; 
            this.mail.subject = this.activeSurveyTitle ;
            this.mail.to = requester;//"sylvia.germe@echr.coe.int";//
            this.mail.from = from;
           // console.log(mailmessage);
            var result = this._surveyService.ManageSurveyAnswer(this.mail);

        }

    }

 



}



